import axiosInstance from '../utils/axiosConfig'
import { mobileBackendUrl } from '../env'
import { eliteWrappedMockData } from '../data/eliteWrappedMockData'
import { EliteWrappedFrame, EliteWrappedResponse } from '../types/eliteWrapped.types'

const ELITE_RENEWAL_STATUSES = ['EXPIRED_ELITE', 'RENEWED_ELITE', 'PENDING_RENEWAL_ELITE'] as const

function parseEliteRenewalStatus(value: unknown): EliteWrappedResponse['eliteRenewalStatus'] | undefined {
  if (typeof value !== 'string') return undefined
  if (ELITE_RENEWAL_STATUSES.includes(value as EliteWrappedResponse['eliteRenewalStatus'])) {
    return value as EliteWrappedResponse['eliteRenewalStatus']
  }
  return undefined
}

function parseEliteWrappedPayload(payload: unknown): EliteWrappedResponse | undefined {
  if (!payload || typeof payload !== 'object') return undefined

  const root = payload as Record<string, unknown>
  const frameData = root?.frameData
  if (!Array.isArray(frameData) || frameData.length === 0) return undefined

  const eliteRenewalStatus = parseEliteRenewalStatus(root?.eliteRenewalStatus ?? root?.elite_renewal_status)
  if (!eliteRenewalStatus) return undefined

  return {
    frameData: frameData as EliteWrappedFrame[],
    eliteRenewalStatus
  }
}

/** API body may be the payload directly or wrapped as `{ data: payload }`. */
export function parseEliteWrappedResponse(httpBody: unknown): EliteWrappedResponse | undefined {
  const direct = parseEliteWrappedPayload(httpBody)
  if (direct) return direct

  if (!httpBody || typeof httpBody !== 'object') return undefined
  const nested = (httpBody as Record<string, unknown>)?.data
  return parseEliteWrappedPayload(nested)
}

function isErrorScreenPayload(body: unknown): boolean {
  if (!body || typeof body !== 'object') return false
  const root = body as Record<string, unknown>
  return root?.responseType === 'SCREEN' || root?.type === 'GENERAL_ERROR_SCREEN'
}

export const fetchEliteUsersWrap = async (): Promise<EliteWrappedResponse> => {
  try {
    const response = await axiosInstance.get(`${mobileBackendUrl}/v2/portfolio/elite-users-wrap`)
    const body = response?.data
    if (isErrorScreenPayload(body)) {
      throw new Error('Elite wrap unavailable')
    }
    const parsed = parseEliteWrappedResponse(body)
    if (parsed) {
      return parsed
    }
  } catch {
    // API unavailable — fall back to mock
  }
  return eliteWrappedMockData
}
